import { useState } from "react";
import { Button } from "@/components/ui/button";
import { SrIcon } from "@/components/ui/SrIcon";
import ContractStatusBadge from "./ContractStatusBadge";
import GenerateContractDialog from "./GenerateContractDialog";
import type { ExtraContract } from "@/hooks/use-extra-contracts";

interface Props {
  extraId: string;
  extraName: string;
  projectId: string;
  contract: ExtraContract | undefined;
}

/**
 * VIB-1281: kontrakt-cellen i StatisterTable-raden. Egen fil (ikke inline i
 * ExtraDetailRow) fordi ExtraDetailRow/StatisterTable allerede er nær
 * 300-linjersgrensen — se endringssjekk-notatet i VIB-1281.
 * Synligheten styres av `feature_contracts` i callers (StatisterTab), IKKE
 * her, slik at komponenten forblir en ren presentasjons-/dialog-wrapper.
 */
export default function ExtraContractCell({ extraId, extraName, projectId, contract }: Props) {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <div className="flex items-center gap-1.5" onClick={(e) => e.stopPropagation()}>
      <ContractStatusBadge status={contract?.status} />
      <Button
        size="sm"
        variant="ghost"
        className="h-6 px-1.5 text-xs opacity-0 group-hover:opacity-100 focus-visible:opacity-100 group-focus-within:opacity-100 transition-opacity"
        onClick={() => setDialogOpen(true)}
        title={contract ? "Regenerer kontrakt" : "Generer kontrakt"}
      >
        <SrIcon name="file-text" className="w-3 h-3" />
      </Button>
      {dialogOpen && (
        <GenerateContractDialog
          open={dialogOpen}
          onOpenChange={setDialogOpen}
          extraId={extraId}
          extraName={extraName}
          projectId={projectId}
          contract={contract}
        />
      )}
    </div>
  );
}
